import React from 'react';
import { LocationWrapper, LocationInfo, LocationName, LocationAddress, MapLink } from './MessageLocation.styled';

type MessageLocationProps = {
  name?: string;
  address?: string;
  latitude?: number;
  longitude?: number;
};

export function MessageLocation({ name, address, latitude, longitude }: MessageLocationProps) {
  const mapsUrl = latitude != null && longitude != null ? `https://maps.google.com/?q=${latitude},${longitude}` : null;

  return (
    <LocationWrapper>
      <span>📍</span>
      <LocationInfo>
        {name && <LocationName>{name}</LocationName>}
        {address && <LocationAddress>{address}</LocationAddress>}
        {mapsUrl && (
          <MapLink href={mapsUrl} target="_blank" rel="noopener noreferrer">
            Ver no Google Maps ↗
          </MapLink>
        )}
      </LocationInfo>
    </LocationWrapper>
  );
}
